import React, { useState, useEffect } from "react";
import {
  Button,
  Divider,
  Grid,
  TextField,
  MenuItem,
  Select,
  InputLabel,
  FormControl,
} from "@mui/material";
import patientService from "../../../Services/patientService";
import toast from "react-hot-toast";
import { useNavigate, useParams } from "react-router-dom";
import purchaseService from "../../../Services/purchaseService";
import medicineService from "../../../Services/medicineService";

const RecordPurchases = () => {
  const [patientData, setPatientData] = useState({
    stock_id: "",
    quantity: "",
    unit_price: "",
    purchase_date: "",
    invoice: "",
  });

  const [medicineData, setMedicineData] = useState([]);

  const { id } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    if (id) {
      const fetchPatientData = async () => {
        try {
          const response = await patientService.fetchPatientById(id); 
          setMedicineData(response.patient);
        } catch (error) {
          toast.error("Error fetching patient data.");
        }
      };

      fetchPatientData();
    }
  }, [id]);

  useEffect(() => {
    const getProducts = async () => {
      try {
        const response = await medicineService.fetchAll();
        setMedicineData(response.medicines); 
      } catch (error) {
        toast.error("Error fetching Doctors");
      }
    };
    getProducts();
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setPatientData({ ...patientData, [name]: value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      if (id) {
        await purchaseService.update(id, patientData);
        toast.success("Medicine updated successfully!");
      } else {
        await purchaseService.save(patientData);
        toast.success("Medicine added successfully!");
      }
      navigate("/patients");
    } catch (error) {
      toast.error("Error saving patient.");
    }
  };

  return (
    <form onSubmit={handleSubmit} className="w-[90%] m-auto">
      <h1 className="m-[30px] text-center font-[700] text-[20px]">
        {id ? "Edit Purchases" : "Record Purchases"}
      </h1>
      <Divider />
      <div>
        <Divider className="my-[20px]" />

        <div className="grid grid-cols-2 gap-10 my-[20px]">
          <div>
            <FormControl fullWidth>
              <InputLabel>Medicine Name</InputLabel>
              <Select
                label="Medicine Name"
                name="stock_id"
                value={patientData.stock_id} 
                onChange={handleChange}
                required
              >
                {medicineData.map((medicines) => (
                  <MenuItem key={medicines.id} value={medicines.id}>
                    {medicines.medicine_name}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </div>
          <div>
            <TextField
              label="Quantity"
              variant="outlined"
              fullWidth
              type="number"
              name="quantity"
              value={patientData.quantity}
              onChange={handleChange}
              required
            />
          </div>
        </div>

        <div className="grid grid-cols-4 gap-10 my-[20px]">
          <div>
            <TextField
              label="Purchase Price"
              variant="outlined"
              fullWidth
              type="number"
              name="p_price"
              value={patientData.p_price}
              onChange={handleChange}
              required
            />
          </div>

          <div>
            <TextField
              label="Unit Price"
              variant="outlined"
              fullWidth
              type="number"
              name="unit_price"
              value={patientData.unit_price}
              onChange={handleChange}
              required
            />
          </div>

          <div>
            <TextField
              label="Purchase Date"
              variant="outlined"
              fullWidth
              type="date"
              name="purchase_date"
              value={patientData.purchase_date}
              onChange={handleChange}
              required
              InputLabelProps={{
                shrink: true,
              }}
            />
          </div>

          <div>
            <TextField
              label="Invoice"
              variant="outlined"
              fullWidth
              type="number"
              name="invoice"
              value={patientData.invoice}
              onChange={handleChange}
              required
            />
          </div>
        </div>

        <div className="text-center my-[30px]">
          <Button type="submit" variant="contained" color="primary">
            {id ? "Update Medicine" : "Add Medicine"}
          </Button>
        </div>
      </div>
    </form>
  );
};

export default RecordPurchases;
